import { ReactNode, Ref, useEffect, useRef } from "react";
import Heading from "../sheriff-wrappers/Heading";
import { useLocation } from "react-router";
import { SDSDialog } from "@politiet/sheriff-web-components";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  tittel: string;
  children: ReactNode;
  knapper?: ReactNode;
  headerSize?: "xs" | "s" | "m" | "l" | "xl";
  "data-testid"?: string;
  ref?: Ref<SDSDialog>;
}

export function ModalUtenLocation({
  isOpen,
  onClose,
  tittel,
  children,
  knapper,
  headerSize = "m",
  "data-testid": dataTestId,
  ref,
}: ModalProps) {
  const previousTargetedElement = useRef<HTMLElement>(null);

  useEffect(() => {
    if (isOpen) {
      if (previousTargetedElement.current == null) {
        previousTargetedElement.current = document.activeElement as HTMLElement;
      }
    } else {
      previousTargetedElement.current?.focus();
    }

    return () => {
      previousTargetedElement.current?.focus();
    };
  }, [isOpen]);

  return (
    <sds-dialog
      ref={ref}
      data-testid={dataTestId}
      open={isOpen}
      onsds-close={onClose}
      modal
      closedby="any"
    >
      {tittel && (
        <Heading slot={"header"} level={"h2"} size={headerSize}>
          {tittel}
        </Heading>
      )}
      {children}
      <div slot={"footer"}>{knapper}</div>
    </sds-dialog>
  );
}

export function Modal(props: ModalProps) {
  const { hash } = useLocation();

  const dialogRef = useRef<SDSDialog>(null);

  useEffect(() => {
    async function awaitDialogOpen() {
      if (!dialogRef.current) {
        return;
      }

      //sett fokus på riktig element når modalen er klar for det
      await dialogRef.current.updateComplete;
      const element = document.getElementById(hash.substring(1));
      if (element) {
        element.focus();
      }
    }

    void awaitDialogOpen();
  }, [hash]);

  return <ModalUtenLocation ref={dialogRef} {...props} />;
}
